import React, { useState } from 'react';

interface FormFieldProps {
  label: string;
  name: string;
  type: 'text' | 'email' | 'password' | 'tel' | 'date';
  value: string;
  onChange: (value: string) => void;
  error?: string;
  placeholder?: string;
  disabled?: boolean;
  autoComplete?: string;
  required?: boolean;
  maxLength?: number;
  /** Upper bound for date inputs (YYYY-MM-DD), e.g. to block future dates */
  max?: string;
  onPaste?: (e: React.ClipboardEvent<HTMLInputElement>) => void;
  onCopy?: (e: React.ClipboardEvent<HTMLInputElement>) => void;
  onCut?: (e: React.ClipboardEvent<HTMLInputElement>) => void;
  /** Variant for border styling: 'default' (light blue) or 'outlined' (gray border) */
  variant?: 'default' | 'outlined';
}

export const FormField = React.memo<FormFieldProps>(({
  label,
  name,
  type,
  value,
  onChange,
  error,
  placeholder,
  disabled = false,
  autoComplete,
  required = false,
  maxLength,
  max,
  onPaste,
  onCopy,
  onCut,
  variant = 'default',
}) => {
  const [showPassword] = useState(false);

  const isPasswordField = type === 'password';
  const inputType = isPasswordField && showPassword ? 'text' : type;

  return (
    <div className="space-y-2">
      <label
        htmlFor={name}
        className="block text-sm font-semibold text-text-secondary"
      >
        {label}
      </label>

      <div className="relative">
        <input
          id={name}
          name={name}
          type={inputType}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          disabled={disabled}
          autoComplete={autoComplete}
          required={required}
          maxLength={maxLength}
          max={max}
          onPaste={isPasswordField ? (e) => { e.preventDefault(); onPaste?.(e); } : onPaste}
          onCopy={isPasswordField ? (e) => { e.preventDefault(); onCopy?.(e); } : onCopy}
          onCut={isPasswordField ? (e) => { e.preventDefault(); onCut?.(e); } : onCut}
          className={`w-full px-3 py-3 rounded-lg text-sm bg-white focus:outline-none focus:ring-2 disabled:bg-gray-50 disabled:cursor-not-allowed ${
            variant === 'outlined' ? 'form-field-outlined' : ''
          } ${
            error
              ? 'focus:ring-red-500'
              : variant === 'outlined' ? 'focus:ring-blue-500' : 'focus:ring-[#1B84C6]'
          }`}
          style={{
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: error
              ? '#fca5a5'
              : variant === 'outlined'
                ? '#d1d5db'
                : '#D9F0FF'
          }}
        />

        {/* {isPasswordField && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
          >
            {showPassword ? (
              <EyeOff className="w-5 h-5" />
            ) : (
              <Eye className="w-5 h-5" />
            )}
          </button>
        )} */}
      </div>

      {error && (
        <p className="text-sm" style={{ color: '#CA7373' }}>
          {error}
        </p>
      )}
    </div>
  );
});

FormField.displayName = 'FormField';
